import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import Label from "../../../components/Label";

const StepFour = ({ locationDetails, setLocationDetails }) => {
  const handleSelect = async (place) => {
    if (!place) return;
    const placeId = place.value.place_id;
    const address = place.label;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?place_id=${placeId}&key=AIzaSyDgm3VBE9YF9fIYqHU6Cue4OfJBtJBlxj4`
      );
      const data = await response.json();

      if (data.status === "OK") {
        const location = data.results[0].geometry.location;
        setLocationDetails({
          address,
          lat: location.lat,
          lng: location.lng,
          placeId,
        });
      } else {
        console.error("Geocode error:", data.status);
      }
    } catch (error) {
      console.error("Geocode fetch error:", error);
    }
  };

  return (
    <Box>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12} sm={8} md={4.5}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              marginBottom: "15px",
              color: "rgb(178 181 178)",
            }}
          >
            Account Setup
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "30px", marginBottom: "15px" }}
          >
            Set your location
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "400",
              fontSize: "15px",
              marginBottom: "15px",
              color: "rgb(178 181 178)",
            }}
          >
            Add your business location so your clients can easily find you.
          </Typography>

          <Box
            sx={{
              padding: "25px",
              border: "1px solid rgb(178 181 178)",
              borderRadius: "15px",
            }}
          >
            <Label
              labelText="Where's your business located?"
              htmlFor={"location"}
              required
            />
            <GooglePlacesAutocomplete
              apiKey="AIzaSyDgm3VBE9YF9fIYqHU6Cue4OfJBtJBlxj4"
              selectProps={{
                onChange: handleSelect,
              }}
            />
            <FormControlLabel
              sx={{ marginTop: "10px" }}
              control={<Checkbox size="medium" />}
              label="I don't have a business address (mobile and online services only)"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StepFour;
